import { render } from "./ProductCounter.vue?vue&type=template&id=4d60690a"
import script from "./ProductCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCounter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/ProductCounter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d60690a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d60690a', __exports__)) {
    console.log('reload')
    api.reload('4d60690a', __exports__)
  }
  
  module.hot.accept("./ProductCounter.vue?vue&type=template&id=4d60690a", () => {
    console.log('re-render')
    api.rerender('4d60690a', render)
  })

}


export default __exports__